<template>
    <div class="col-12">
        <div v-show="showNotInvoicedTable">
            <table class="table table-responsive d-sm-table table-bordered tabs-elev-table mb-0 text-sm">
                <thead class="bg-primary-lighter text-white">
                <tr>
                    <th v-if="selectable" scope="col" class="border-left-0 border-right-0 border-bottom-0 border-top-0 text-center"></th>
                    <th scope="col" class="border-left-0 border-right-0 border-bottom-0 border-top-0" style="min-width: 80px">{{ $t('Dato') }}</th>
                    <th scope="col" class="border-left-0 border-right-0 border-bottom-0 border-top-0" style="min-width: 150px;">{{ $t('Produkt') }}</th>
                    <th scope="col" class="border-left-0 border-right-0 border-bottom-0 border-top-0 d-none d-sm-table-cell">{{ $t('Ant.') }}</th>
                    <th scope="col" class="border-left-0 border-right-0 border-bottom-0 border-top-0 text-end"><span class="d-block d-sm-none">{{ $t('sale-short') }}</span><span class="d-none d-sm-block">{{ $t('Salg') }}</span></th>
                </tr>
                </thead>
                <tbody>
                <Sale
                    v-for="sale in sales"
                    :sale_index="sale.sale_id"
                    :sale_prop="sale"
                    :key="sale.sale_id"
                    :hide-sales="1"
                    :selectable="selectable"
                    :selected="isSelected(sale.sale_id)"
                    :display-payable-amount="true"
                    @toggle-selection="toggleSelection"
                ></Sale>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import Sale from '../account/Sale.vue';

const props = defineProps(['amount', 'sales', 'amountFormatted', 'selectable', 'selectedSaleIds']);
const emit = defineEmits(['toggle-selection']);
const showNotInvoicedTable = ref(true);

const isPayable = computed(() => props.amount > 0);
const selectable = computed(() => props.selectable === true);

const toggleNotInvoicedTable = () => {
    showNotInvoicedTable.value = !showNotInvoicedTable.value;
};

const isSelected = (saleId) => (props.selectedSaleIds ?? []).includes(Number(saleId));
const toggleSelection = (saleId) => emit('toggle-selection', saleId);

</script>
